"use client";
import * as React from "react";
const SvgStarFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 15", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m8 11.56 4.94 2.94-1.3-5.55L16 5.22l-5.75-.49L8-.5 5.75 4.73 0 5.22l4.37 3.73-1.31 5.55z" }));
export {
  SvgStarFilled as default
};
